module.exports = __webpack_public_path__ + "static/media/cover3.9f4d5a70.jpg";